import {Injectable} from '@angular/core';
import { IEndpoint } from '../../viba/admin/endpoint/endpoints';
import { TranslateService } from '@ngx-translate/core';
import { ListViewPreferencesService } from './list-view-preferences.service';
import { ActivatedRoute } from '@angular/router';
import { ConfirmDialogService } from '../confirm-dialog.service';
import { BulkOperationEvent, ListViewFilter } from './list-view.component';
import { isEmpty } from 'lodash-es';
import { NotificationService } from '../notification.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ListViewHelperService {

  public bulkOperationCompletedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public bulkOperationCompleted$ = this.bulkOperationCompletedSubject.asObservable();

  constructor(
    private translateService: TranslateService,
    private preferencesService: ListViewPreferencesService<any>,
    private route: ActivatedRoute,
    private dialogService: ConfirmDialogService,
  ) {
  }

  loadSavedFilters(listIdentifier: string, component: any, tableFilters: ListViewFilter[]) {
    const savedFilters = this.preferencesService.getSavedFilters(listIdentifier);
    if (savedFilters !== null) {
      tableFilters.forEach((filter: ListViewFilter) => {
        const value = savedFilters[filter.filterDef];
        if (typeof value !== 'undefined') {
          component[filter.filterDef] = value;
        } else if (filter.filterDefaultValue !== 'undefined') {
          component[filter.filterDef] = filter.filterDefaultValue;
        }
      });
    } else {
      this.setDefaultsForFilters(tableFilters, component);
    }
  }

  updateFieldsFromQueryParams(tableFilters: ListViewFilter[], component: any) {
    const queryParams = this.route.snapshot.queryParams;
    if (!isEmpty(queryParams)) {
      tableFilters.forEach(filter => {
        const query = queryParams[filter.filterDef];

        if (query?.length) {
          if (typeof filter.filterValueTransformer !== 'undefined') {
            component[filter.filterDef] = filter.filterValueTransformer(query);
          } else {
            component[filter.filterDef] = query;
          }
        }
      });
    }
  }

  deleteFilters(tableFilters: ListViewFilter[], component: any) {
    tableFilters.forEach(filter => {
      if (typeof filter.filterDefaultValue === 'undefined') {
        delete component[filter.filterDef];
      }
    });
    this.setDefaultsForFilters(tableFilters, component);
  }

  setDefaultsForFilters(tableFilters: ListViewFilter[], componnet: any) {
    tableFilters.forEach((filter: ListViewFilter) => {
      if (typeof filter.filterDefaultValue !== 'undefined') {
        componnet[filter.filterDef] = filter.filterDefaultValue;
      }
    });
  }

  executeBulkOperation(
    event: BulkOperationEvent<IEndpoint>,
    component: any,
    bulkOperationService: any,
    notificationService: NotificationService,
  ) {
    const selectedItems = event.bulkOperationSelection.itemsSelectedCount;
    const statusName = event.type === 'DELETE' ? 'archive' : event.type.toLowerCase();
    const auxText = `Are you sure you want to ${statusName} ${selectedItems} records?`;
    const messageText = this.translateService.stream(marker(auxText));

    this.dialogService.openConfirmDialog(messageText)
      .subscribe(dialogStatus => {
        if (dialogStatus) {
          const endpointIds = event.bulkOperationSelection.items.map(item => item.id);
          bulkOperationService.bulkOperation(endpointIds, event.type, event.bulkOperationSelection.filters)
            .subscribe((response) => {
              if (response === null) {
                const message = this.translateService.stream(marker('Operation executed successfully!'));
                notificationService.success(message);
                component.list.loadItems(true);
              }
            });
        }
      });
  }

  toInteger(value: any): number {
    if (typeof value === 'string') {
      return parseInt(value, 10);
    }
  }

  toArrayOfStrings(value: any): string[] {
    if (typeof value === 'string') {
      return value.split(',');
    }
  }

  toArrayOfIntegers(value: any): number[] {
    if (typeof value === 'string') {
      return value.split(',').map(str => parseInt(str, 10));
    }
  }

}
